import styled from "styled-components";

export const Container = styled.div`
  padding: 0px;
`;

export const Title = styled.h1`
  color: #181818;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
`;

export const PageHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`;

export const Download = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const DownloadOptions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 3px;

  & div {
    cursor: pointer;
  }
`;

export const BackBtn = styled.button`
  appearance: none;
  background-color: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  color: #181818;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  justify-content: space-between;
  border: none;
  background: none;
`;
